function setEqualHeight(selector) {
  const divs = document.querySelectorAll(selector);
  const maxHeight = Math.max(...Array.from(divs, (div) => div.offsetHeight));
  divs.forEach((div) => {
    div.style.height = `${maxHeight}px`;
  });
}
function setEqualHeightv3(collection, selector) {
  let divs = collection.querySelectorAll(selector);
  let max = 0;

  // First pass: Calculate the maximum height
  divs.forEach((div) => {
    // let height = div.clientHeight;
    let temp = window.getComputedStyle(div);
    let height = parseFloat(temp.getPropertyValue("height"));

    if (height > max) {
      console.log("Height: ", height, " Max: ", max);
      max = height;
    } else {
      console.log("Lesser Height: ", height, " Max: ", max);
    }
  });

  // Second pass: Set all divs to the max height
  divs.forEach((div) => {
    console.log("Set  Max: ", max);
    div.style.height = `${max}px`;
  });
}




// window.customFormSubmit = () => {
//   document.querySelectorAll(".product-quick-add").forEach(btn => {
//     btn.addEventListener("click", e => {
//       e.preventDefault();

//       const form = btn.closest("form");
//       const formData = new FormData(form);

//       // Step 1: Add product to cart
//       fetch(`${window.Shopify.routes.root}cart/add.js`, {
//         method: 'POST',
//         body: formData
//       })
//         .then(response => response.json())
//         .then(() => {
//           // Step 2: Get the updated drawer HTML from Shopify sections API
//           return fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
//         })
//         .then(response => response.json())
//         .then(data => {
//           const html = data['cart-drawer'];

//           const parser = new DOMParser();
//           const newDoc = parser.parseFromString(html, 'text/html');
//           const newCartDrawer = newDoc.querySelector('cart-drawer');
//           const existingCartDrawer = document.querySelector('cart-drawer');

//           // Step 3: Replace the whole <cart-drawer> element
//           if (newCartDrawer && existingCartDrawer) {
//             existingCartDrawer.replaceWith(newCartDrawer);
//           }

//           // Step 4: Reopen the drawer after replacement
//           const updatedDrawer = document.querySelector('cart-drawer');
//           if (updatedDrawer && typeof updatedDrawer.open === 'function') {
//             initswiperincart();
//             updatedDrawer.open();
//             // slidercustomFormSubmit();
//           }
//         })
//         .catch((error) => {
//           console.error('Add to Cart Error:', error);
//         });
//     });
//   });
// };

window.customFormSubmit = () => {
  document.querySelectorAll(".product-quick-add").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const form = btn.closest("form");
      const formData = new FormData(form);
      let xcart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      // let addToCartForm = xcart.querySelector('form[action$="/cart/add"]');
      // let formData = new FormData(addToCartForm);

      if (xcart) {
        formData.append(
          "sections",
          xcart.getSectionsToRender().map((section) => section.id)
        );
      }

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          xcart.renderContents(response);
        })
        .finally(() => {
          if (xcart && xcart.classList.contains("is-empty"))
            xcart.classList.remove("is-empty");
          initswiperincart();
        });
    });
  });
};

// Initialize it
customFormSubmit();

  